import clienteAxios from "../config/axios";

export async function getAbmProduct () {
    return clienteAxios.get(`/abmProduct`);
}

export async function getAbmProductByTDoc (tDocCodFor, tDocNroFor) {
    return clienteAxios.post(`/abmProduct/byTDoc`, { tDocCodFor, tDocNroFor});
}

export async function uploadAbmProduct ( userID, userName) {
    return clienteAxios.post('/abmProduct/actualizar', {userID, userName});
}

export async function uploadProduct(product){
    return clienteAxios.post('/abmProduct/add',{product});
}

export async function updateProduct(product){
    return clienteAxios.put('/abmProduct/update',{product});
}

export async function getDataByProd(tippro, artcod, periodo){
    return clienteAxios.get(`/product/getConsumos/${tippro}/${artcod}/${encodeURIComponent(periodo)}`);
}